import type { InjectionKey } from 'vue'

export interface PriceFormatterOptions {
  currency?: string | false
  locale?: string
}

export interface PriceFormatter {
  formatPrice: (value: number, overrides?: PriceFormatterOptions) => string
}

export const priceFormatterKey: InjectionKey<PriceFormatter> = Symbol('PriceFormatter')

export function PriceFormatter(options: PriceFormatterOptions = {}): PriceFormatter {
  const { currency = 'CHF', locale = 'de-CH' } = options

  function formatPrice(value: number, overrides: PriceFormatterOptions = {}): string {
    const cur = overrides.currency ?? currency
    const loc = overrides.locale ?? locale

    const formatted = new Intl.NumberFormat(loc, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value)

    const withDash = formatted.endsWith(',00') || formatted.endsWith('.00')
      ? formatted.slice(0, -3) + '.–'
      : formatted

    return cur ? `${withDash} ${cur}` : withDash
  }

  return { formatPrice }
}